import actions from "./actions";
import { UserType } from '../../components/Access/helper/permission/enum/UserType';
import {SubscriptionStatus} from "../../enums/SubscriptionStatus";
import {
    SubscriptionScopeDummy,
    useDummyData } from "../../components/Access/dummy";

const initSubscription = {
    plan_id: null, // null
    is_trial: true,
    plan: {},
    scopes: {},
    status: SubscriptionStatus.none, // string (trial, trial_ended)
    trial_ends_at: null, // string (YYYY-MM-DD HH:mm:ss)
    ends_at: null, // string (YYYY-MM-DD HH:mm:ss)
    suspended_at: null, // string (YYYY-MM-DD HH:mm:ss)
};

const initState = {
    urlMode: null,
    accessToken: null,
    resetPasswordShow: false,
    resetPasswordEmail: null,
    remember: false,
    // session: {
    //     company: {},
    //     access: {
    //         type: null,
    //         permissions: {},
    //     },
    // },

    // Validate
    access: {},
    subscription: initSubscription,
    company: {},
    user: {},
    apps: [],

    // Derived from Validate
    subdomain: null,
    companyCurrencyCode: null,
    companyCurrencySymbol: null,
    companyRegNo: null,
    oldCompanyRegNo: null,
    companyCountryCode: null,

    isOwner: null,
    isAdmin: null,
    isPartner: null,
    isClient: null,
    partnerManageUsers: null, // if the current client company grants partner to manage users

    // The Rest
    invite: null,
    sessionReady: false,
    registerState: null,
    registerResult: null,
    loginState: null,
    loginResult: null,
    validateSessionState: null,
    readInviteState: null,
    acceptInviteState: null,
    activateState: null,
    sendActivationCodeState: null,
    accessDeniedModal: {
        visible: false,
        featureSelected: null,
    },
    readAccountSetsState: null,
    accountSets: null,

};

// const launchFeature = {
//   [Feature.sales]: true,
//   [Feature.purchase]: false,
//   [Feature.batch_sales]: false,
//   [Feature.multi_currency]: false,
// }

// const premiumFeature = {
//   [Feature.sales]: true,
//   [Feature.purchase]: true,
//   [Feature.batch_sales]: true,
// }

// const testFeature = launchFeature

// function overwriteSubscription(session){
//   return {
//     ...session,
//     subscription: {
//       ...session.subscription,
//       plan: {
//         ...session.subscription.plan,
//         scopes: {...SubscriptionScopeDummy}
//       }
//     }
//   }
// }
function overwriteSubscription(session) {
    return {
        ...session,
        subscription: {
            ...session.subscription,
            plan: {
                ...session.subscription.plan,
                scopes: {...SubscriptionScopeDummy},
            },
            previous_plan_valid_until: "2023-10-21 10:00:00",
            previous_plan: {
                features: {
                    ...SubscriptionScopeDummy,
                    // override any values here
                    DASHBOARD: false,
                },
                // features: { // To be renamed, likely another story.
                //     SALE: false,
                //     DASHBOARD: false,
                //     SALE_BATCH: false,
                //     PURCHASE: false,
                //     PURCHASE_BATCH: true,
                //     DIGITAL_SHOEBOX: true,
                //     BANK: true,
                //     BANK_BATCH: true,
                //     BANK_RECONCILIATION: true,
                //     PRODUCT_INVENTORY: false,
                //     PRODUCT_INVENTORY_MULTI_LOCATION: true,
                //     PRODUCT_MULTI_UOM: true,
                //     PRODUCT_MULTI_PRICE: true,
                //     REPORT: true,
                //     ACCOUNTING_JOURNAL_ENTRY: true,
                //     ASSET: true,
                //     INSTRUCTION: true,
                //     MULTI_CURRENCY: true,
                //     TAG: false,
                //     TAX_SST: false,
                //     FIELD: true,
                //     EMAIL_TRACKER: true,
                //     E_INVOICING: true,
                //     INVOICE_REMINDER: true,
                //     PAYMENT_GATEWAY: true,
                //     MULTI_USER: true,
                //     MULTI_NUMBER_FORMAT: true,
                //     MULTI_FORM_DESIGN: true,
                //     USER_PERMISSION_LEVEL_1: true,
                //     USER_PERMISSION_LEVEL_2: false,
                // },
            },
            current_plan: {
                features: {...SubscriptionScopeDummy},
                // features: { // To be renamed, likely another story.
                //     SALE: true,
                //     SALE_BATCH: true,
                //     PURCHASE: true,
                //     PURCHASE_BATCH: true,
                //     DIGITAL_SHOEBOX: true,
                //     BANK: true,
                //     BANK_BATCH: true,
                //     BANK_RECONCILIATION: true,
                //     PRODUCT_INVENTORY: true,
                //     PRODUCT_INVENTORY_MULTI_LOCATION: true,
                //     PRODUCT_MULTI_UOM: true,
                //     PRODUCT_MULTI_PRICE: true,
                //     REPORT: true,
                //     ACCOUNTING_JOURNAL_ENTRY: true,
                //     ASSET: true,
                //     INSTRUCTION: true,
                //     MULTI_CURRENCY: true,
                //     TAG: true,
                //     TAX_SST: true,
                //     FIELD: true,
                //     EMAIL_TRACKER: false,
                //     E_INVOICING: false,
                //     INVOICE_REMINDER: false,
                //     PAYMENT_GATEWAY: false,
                //     MULTI_USER: false,
                //     MULTI_NUMBER_FORMAT: true,
                //     MULTI_FORM_DESIGN: true,
                //     USER_PERMISSION_LEVEL_1: true,
                //     USER_PERMISSION_LEVEL_2: false,
                // },
            },

            // scopes: {...SubscriptionScopeDummy},
        },
    };
}

export default function authReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.REGISTER_REQUEST:
            return {
                ...state,
                registerState: 'request',
                loginState: null,
            };
        case actions.REGISTER_SUCCESS:
            return {
                ...state,
                registerState: 'success',
                registerResult: action.data,
                accessToken: action.accessToken,
                subdomain: action.subdomain,
                // features: testFeature,
            };
        case actions.REGISTER_ERROR:
            return {
                ...state,
                registerState: 'error',
            };
        case actions.ACTIVATE_REQUEST:
            return {
                ...state,
                activateState: 'request',
            };
        case actions.ACTIVATE_SUCCESS:
            return {
                ...state,
                activateState: 'success',
            };
        case actions.SEND_ACTIVATION_CODE_REQUEST:
            return {
                ...state,
                sendActivationCodeState: 'request',
            };
        case actions.SEND_ACTIVATION_CODE_SUCCESS:
            return {
                ...state,
                sendActivationCodeState: 'success',
            };
        case actions.LOGIN_REQUEST:
            return {
                ...state,
                loginState: 'request',
            };
        case actions.LOGIN_SUCCESS:
            return {
                ...state,
                loginState: 'success',
                loginResult: action.data,
                accessToken: action.accessToken,
                subdomain: action.subdomain,
                urlMode: action.urlMode,
                remember: action.remember,
                // features: {...testFeature},
            };
        case actions.LOGIN_ERROR:
            return {
                ...state,
                loginState: 'error',
            };
        case actions.REAUTHENTICATE_REQUEST:
            return {
                ...state,
                reauthenticateState: 'request',
            };
        case actions.REAUTHENTICATE_SUCCESS:
            return {
                ...state,
                reauthenticateState: 'success',
            };
        case actions.RESET_TOKEN_SUCCESS:
            return {
                ...state,
                resetPasswordShow: true,
                resetPasswordEmail: action.resetPasswordEmail,
            };
        case actions.RESET_PASSWORD_HIDE:
            return {
                ...state,
                resetPasswordShow: false,
                resetPasswordEmail: null,
            };
        case actions.CHECK_AUTHORIZATION_SUCCESS:
            return {
                ...state,
                accessToken: action.accessToken,
                subdomain: action.subdomain,
                // features: {...testFeature},
            };
        case actions.VALIDATE_SESSION_REQUEST:
            return {
                ...state,
                sessionReady: false,
                validateSessionState: 'request',
            };
        case actions.VALIDATE_SESSION_SUCCESS: {
            const { access = {}, company = {}, user = {}, apps = [] } = action;

            const isOwner = company?.user_id === user?.id;
            const isAdmin = access?.type === UserType.admin;
            const isPartner = company?.is_partner;
            const isClient = company?.billing_party === 'partner';

            const session = {
                ...state,
                access,
                company,
                user,
                apps,
                subscription: company.subscription || {},

                subdomain: company?.subdomain,
                companyCurrencySymbol: company?.currency_symbol || '',
                companyCurrencyCode: company?.currency_code,
                companyRegNo: company?.reg_no || null,
                oldCompanyRegNo: company?.old_reg_no || null,
                companyCountryCode: company?.country_code || null,
                isOwner,
                isAdmin,
                isPartner,
                isClient,
                partnerManageUsers: company?.partner_manage_users,

                validateSessionState: 'success',
            };

            // return session
            return useDummyData ? overwriteSubscription(session) : session;
        }
        case actions.SET_SESSION_READY:
            return {
                ...state,
                sessionReady: true,
            };
        case actions.VALIDATE_SESSION_ERROR:
            return {
                ...state,
                validateSessionState: 'error',
                validateSessionErrorStatusCode: action.error?.statusCode,
            };
        case actions.READ_INVITE_REQUEST:
            return {
                ...state,
                readInviteState: 'request',
            };
        case actions.READ_INVITE_SUCCESS:
            return {
                ...state,
                readInviteState: 'success',
                invite: action.user,
            };
        case actions.ACCEPT_INVITE_REQUEST:
            return {
                ...state,
                acceptInviteState: 'request',
            };
        case actions.ACCEPT_INVITE_SUCCESS:
            return {
                ...state,
                acceptInviteState: 'success',
                accessToken: action.accessToken,
                subdomain: action.subdomain,
                // features: {...testFeature},
            };
        case actions.LOGOUT:
            return initState;

        case actions.OPEN_ACCESS_DENIED_MODAL:
            return {
                ...state,
                accessDeniedModal: {
                    visible: true,
                    featureSelected: action.feature,
                },
            };
        case actions.CLOSE_ACCESS_DENIED_MODAL:
            return {
                ...state,
                accessDeniedModal: {
                    visible: false,
                    featureSelected: null,
                },
            };
        case actions.CHANGE_SESSION_LOCALE: {
            return {
                ...state,
                user: {
                    ...state.user,
                    locale: action.locale,
                },
            };
        }
        case actions.READ_ACCOUNT_SETS_REQUEST: {
            return {...state,
                readAccountSetsState: 'request',
            };
        }
        case actions.READ_ACCOUNT_SETS_SUCCESS: {
            return {...state,
                readAccountSetsState: 'success',
                accountSets: action.accountSets,
            };
        }
        default:
            return state;
    }
}
